import { Box, Typography } from "@mui/material";
import { isValidElement } from "react";
import {
  RO_DETAIL_COLORS,
  RO_DETAIL_FONT,
} from "../../data/inRepairRoDetailConstants";

const isEmptyValue = (value) =>
  value === null ||
  value === undefined ||
  value === "" ||
  (typeof value === "string" && !value.trim());

const RoDetailField = ({ label, value, valueSx }) => (
  <Box>
    <Typography
      sx={{
        fontSize: RO_DETAIL_FONT.fieldLabel,
        color: RO_DETAIL_COLORS.mutedText,
        mb: "1px",
      }}
    >
      {label}
    </Typography>
    <Box
      sx={{
        fontSize: RO_DETAIL_FONT.fieldValue,
        fontWeight: 400,
        color: RO_DETAIL_COLORS.primaryText,
        ...valueSx,
      }}
    >
      {isValidElement(value) ? value : isEmptyValue(value) ? "\u2014" : value}
    </Box>
  </Box>
);

export default RoDetailField;
